import styled from 'styled-components'

export const MiyawakaNav = styled.nav`
  max-width: 800px;
  padding: 0px 0;
  margin: 0 auto;

  .miyawaka-nav__desc {
    line-height: 1.8;
    margin: 20px auto;
  }

  .miyawaka-nav__list {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 50px auto 0;
  }

  .miyawaka-nav__list-item {
    min-width: 50px;
  }

  .miyawaka-nav__list-item-link {
    display: flex;
    width: 200px;
    height: 80px;
  
    position: relative;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    color: #ffffff;
    background-color: #4B4B4B;
    border-radius: 8px;
    margin: 0 8px;

    .miyawaka-nav:hover {
      color: #e20000;
    }
  }

  .miyawaka-nav__list-item-link:hover {
    opacity: 0.9;
  }

  .miyawaka-nav__list-item-link:after {
      content: url('data:image/svg+xml;base64,PHN2ZyB0PSIxNzI0Mjg5NDExNzQyIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjQyNTIiIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTg5MC4zMzUzODUgMzMwLjkxMTIyMmMtMTIuNTc2Mzc0LTEyLjQxNjM5Ni0zMi44MDA3NTMtMTIuMzUyNzQ4LTQ1LjI0ODExMiAwLjE5MjY2Mkw1MTcuMjQ4MzI3IDY2MS45NTE0NTggMTg0LjgzMTkzMSAzMzIuNTEyNzI3Yy0xMi41NzYzNzQtMTIuNDQ3MzU5LTMyLjgwMDc1My0xMi4zNTI3NDgtNDUuMjgwNzk2IDAuMTkyNjYyLTEyLjQ0NzM1OSAxMi41NzYzNzQtMTIuMzUyNzQ4IDMyLjgzMTcxNiAwLjE5MjY2MiA0NS4yODA3OTZsMzUzLjMxMTY1MiAzNTAuMTEyMDgyYzAuNTQzNTgzIDAuNTQzNTgzIDEuMjQ3MTQ0IDAuNjcyNTk4IDEuNzkyNDQ3IDEuMTgzNDk3IDAuMTI3Mjk1IDAuMTI3Mjk1IDAuMTU5OTc4IDAuMjg3MjczIDAuMjg3MjczIDAuNDE2Mjg4IDYuMjM5MTYxIDYuMTc1NTE0IDE0LjM5OTc4NSA5LjI4MDQ3MyAyMi41Mjc3MjUgOS4yODA0NzMgOC4yMjQyNzEgMCAxNi40Nzk1MDUtMy4xNjg2MDYgMjIuNzIwMzg3LTkuNDcxNDE1bDM1MC4xMTIwODItMzUzLjMxMTY1MkM5MDIuOTc1NDA3IDM2My42MTU2NDMgOTAyLjg4MDc5NiAzNDMuMzYwMzAxIDg5MC4zMzUzODUgMzMwLjkxMTIyMnoiIGZpbGw9IiNmZmZmZmYiIHAtaWQ9IjQyNTMiPjwvcGF0aD48L3N2Zz4=');
      position: absolute;
      bottom: 5px;
  }

  @media screen and (max-width: 1047px) {
    .miyawaka-nav__list {
      flex-direction: column;
    }
    .miyawaka-nav__list-item-link {
      height: 70px;
      font-size: 16px;
      margin-bottom: 20px;
    }

    &>img{
      width: 100%;
      margin: 20px auto;
    }
  }
`

export const Main = styled.main`
  .miyawaka-intro__img {
    min-height: 300px;
    width: 100vw;
    padding: 60px 112px;
    margin: 0 calc(50% - 50vw);
    background-image: url(/images/remoteworktown_bg_pc.jpeg);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    text-align: center;
  }
  .miyawaka-intro__movie-block {
    margin: 80px auto 0;
    max-width: 1000px;
    padding: 40px;
    background-color: #dcdcdc;
    border: 1px solid #ccc;
  }
  .miyawaka-intro__movie {
    width: 100%;
    height: 500px;
  }
  .miyawaka-intro__movie-item + .miyawaka-intro__movie-item {
    margin-top: 20px;
  }
  .miyawaka-intro__movie-title {
    margin-top: 10px;
    font-size: 24px;
    font-weight: bold;
    color: #033b7a;
  }
  .miyawaka-news {
    max-width: 1000px;
    margin: 80px auto 0;
  }
  .miyawaka-news__title {
    font-size: 40px;
    text-align: center;
  }
  .miyawaka-news__list {
    margin-top: 80px;
    display: flex;
    flex-wrap: wrap;
  }
  .miyawaka-three-column {
    margin-top: 50px;
    display: flex;
  }
  .miyawaka-three-column__item {
    margin-right: 20px;
    width: 33.3%;
  }
  .miyawaka-three-column__item:last-child {
    margin-right: 0;
  }
  .miyawaka-three-column__title {
    margin-top: 10px;
    width: 100%;
    font-size: 20px;
    color: #20307e;
    line-height: 1.6;
    font-weight: 400;
    text-align: center;
    border-bottom: 2px solid #20307e;
    letter-spacing: -1px;
  }
  .miyawaka-three-column__text {
    margin-top: 10px;
    font-size: 16px;
    line-height: 2;
  }
  .miyawaka-three-column__text-title {
    font-weight: bold;
    margin-top: 5px;
    line-height: 1.5;
  }
  .miyawaka-three-column__img {
    width: 300px;
    height: 200px;
  }
  .miyawaka-concept {
    max-width: 1000px;
    margin: 80px auto 0;
  }
  .miyawaka-concept__title {
    font-size: 40px;
    text-align: center;
    margin-bottom: 80px;
  }
  .miyawaka-concept__block + .miyawaka-concept__block {
    margin-top: 120px;
  }
  .miyawaka-concept__block-title-wrapper {
    display: flex;
    align-items: baseline;
  }
  .miyawaka-concept__icon {
    width: 120px;
    height: 30px;
    margin-right: 30px;
  }
  .miyawaka-concept__block-title {
    font-size: 40px;
    line-height: 1.6;
    font-weight: 400;
    letter-spacing: -2.4px;
  }
  .miyawaka-concept__block-title-sub {
    display: block;
    font-size: 24px;
  }
  .miyawaka-concept__block-text {
    margin-top: 30px;
    font-size: 16px;
    line-height: 2;
  }
  .miyawaka-concept__img-wrapper {
    margin-top: 20px;
    text-align: center;
  }
  .miyawaka-concept__img {
    width: 660px;
  }
  .miyawaka-concept__change {
    margin-top: 20px;
    display: flex;
  }
  .miyawaka-concept__change-img {
    position: relative;
  }
  .miyawaka-concept__change-img + .miyawaka-concept__change-img {
    margin-left: 20px;
  }
  .miyawaka-concept__change-img:hover .miyawaka-concept__img-caption {
    height: 0;
  }
  .miyawaka-concept__img-caption {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    text-align: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.6);
    transition: height 0.6s;
  }
  .miyawaka-concept__img-caption-title {
    font-size: 13px;
    font-weight: bold;
  }
  .miyawaka-concept__img-caption-name {
    font-size: 16px;
  }
  .miyawaka-concept__img-caption-name--narrow {
    font-size: 16px;
    letter-spacing: -1px;
  }
  .miyawaka-concept__change-note {
    position: relative;
  }
  .miyawaka-facility {
    max-width: 1000px;
    margin: 80px auto 0;
  }
  .miyawaka-facility__title {
    font-size: 40px;
    text-align: center;
  }
  .miyawaka-facility__img {
    margin-top: 80px;
    text-align: center;

    img {
      width: 100%;
    }
  }
  .facility-table-scroll-hint {
    display: none;
  }
  .facility-table-wrapper {
    margin-top: 40px;
  }
  .facility-table {
    width: 100%;
    border-collapse: collapse;
  }
  .facility-table__row {
    border-bottom: solid 2px #49b132;
    height: 70px;
  }
  .facility-table__head,
  .facility-table__foot {
    color: #fff;
    background: #49b132;
    padding: 15px 0;
    text-align: center;
  }
  .facility-table__data {
    padding: 15px 0;
    text-align: center;
    line-height: 1.4;
    vertical-align: middle;
  }
  .facility-table__data--small {
    font-size: 11px;
  }
  .facility-table .facility-table__number1,
  .facility-table .facility-table__number2,
  .facility-table .facility-table__number3,
  .facility-table .facility-table__number4,
  .facility-table .facility-table__number5,
  .facility-table .facility-table__number6,
  .facility-table .facility-table__number7,
  .facility-table .facility-table__number8,
  .facility-table .facility-table__number9 {
    position: relative;
    padding: 15px 0 15px 40px;
    text-align: center;
    line-height: 1.4;
    vertical-align: middle;
  }
  .facility-table .facility-table__number1::before,
  .facility-table .facility-table__number2::before,
  .facility-table .facility-table__number3::before,
  .facility-table .facility-table__number4::before,
  .facility-table .facility-table__number5::before,
  .facility-table .facility-table__number6::before,
  .facility-table .facility-table__number7::before,
  .facility-table .facility-table__number8::before,
  .facility-table .facility-table__number9::before {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    display: inline-block;
    content: '';
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
  }
  .facility-table__number1::before {
    background-image: url(/images/remoteworktown_no01.svg);
  }
  .facility-table__number2::before {
    background-image: url(/images/remoteworktown_no02.svg);
  }
  .facility-table__number3::before {
    background-image: url(/images/remoteworktown_no03.svg);
  }
  .facility-table__number4::before {
    background-image: url(/images/remoteworktown_no04.svg);
  }
  .facility-table__number5::before {
    background-image: url(/images/remoteworktown_no05.svg);
  }
  .facility-table__number6::before {
    background-image: url(/images/remoteworktown_no06.svg);
  }
  .facility-table__number7::before {
    background-image: url(/images/remoteworktown_no07.svg);
  }
  .facility-table__number8::before {
    background-image: url(/images/remoteworktown_no08.svg);
  }
  .facility-table__number9::before {
    background-image: url(/images/remoteworktown_no09.svg);
  }
  .miyawaka-links {
    max-width: 1000px;
    margin: 80px auto 0;
    text-align: center;
  }
  .miyawaka-links__title {
    font-size: 40px;
    text-align: center;
  }
  .miyawaka-links__main {
    margin-top: 80px;
    display: flex;
    justify-content: center;
  }
  .miyawaka-links__link-item + .miyawaka-links__link-item {
    margin-left: 80px;
  }
  .miyawaka-links__img-link {
    display: block;
    padding-bottom: 20px;
    border-bottom: 2px solid #ececec;

    img {
      max-width: 100%;
    }
  }
  .miyawaka-links__img-link:hover {
    opacity: 0.7;
  }
  .miyawaka-links__img {
    width: 213px;
    height: 77px;
  }
  .miyawaka-links__link {
    display: block;
    margin-top: 20px;
    text-decoration: none;
    color: #30a8fb;
    font-weight: 700;
  }
  .miyawaka-links__link:hover {
    text-decoration: underline;
  }
  .miyawaka-links__group {
    margin-top: 80px;
  }
  .miyawaka-links__group-title {
    font-size: 24px;
    font-weight: 400;
  }
  .miyawaka-links__group-link-list {
    margin-top: 30px;
    padding-left: 24px;
    line-height: 1.8;
  }
  .miyawaka-links__group-link-item {
    list-style: none;
  }
  .miyawaka-links__group-link {
    text-decoration: none;
    color: #30a8fb;
    font-size: 16px;
  }
  .miyawaka-links__group-link:hover {
    text-decoration: underline;
  }
  .miyawaka-conclusion {
    max-width: 1000px;
    margin: 120px auto 0;
  }
  .miyawaka-conclusion__img {
    text-align: center;

    img{
      max-width: 100%;
    }
  }

  @media screen and (max-width: 1047px) {

    .miyawaka-intro__img {
      min-height: none;
      padding: 40px 24px;
    }
    .miyawaka-intro__movie-block {
      padding: 30px 24px;
    }
    .miyawaka-intro__movie {
      height: 62.5vw;
    }
    .miyawaka-intro__movie-title {
      font-size: 20px;
      line-height: 1.4;
    }
    .miyawaka-news {
      margin-top: 60px;
    }
    .miyawaka-news__title {
      font-size: 24px;
    }
    .miyawaka-news__list {
      flex-direction: column;
    }
    .miyawaka-concept {
      margin-top: 60px;
    }
    .miyawaka-concept__title {
      font-size: 24px;
      margin-bottom: 60px;
    }
    .miyawaka-concept__block-title-wrapper {
      flex-direction: column;
    }
    .miyawaka-concept__block-title {
      font-size: 24px;
      margin-top: 10px;
      line-height: 1.3;
    }
    .miyawaka-concept__block-title-sub {
      font-size: 20px;
      margin-top: 10px;
    }
    .miyawaka-concept__block-text {
      line-height: 1.8;
    }
    .miyawaka-concept__img {
      width: 100%;
    }
    .miyawaka-concept__change {
      flex-direction: column;
      align-items: center;
    }
    .miyawaka-concept__change-img {
      max-width: 300px;
    }
    .miyawaka-concept__change-img + .miyawaka-concept__change-img {
      margin-left: 0;
      margin-top: 20px;
    }
    .miyawaka-concept__img-caption-name {
      font-size: 1.5rem;
    }
    .miyawaka-concept__img-caption-name--narrow {
      font-size: 1.4rem;
    }
    .miyawaka-concept__change-note {
      font-size: 1.5rem;
      text-align: center;
    }
    .miyawaka-three-column {
      flex-direction: column;
      align-items: center;
    }
    .miyawaka-three-column__item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      margin-right: 0;
    }
    .miyawaka-three-column__item + .miyawaka-three-column__item {
      margin-top: 30px;
    }
    .miyawaka-three-column_text {
      margin-left: 0;
    }
    .miyawaka-three-column__text-title {
      margin-top: 10px;
      font-size: 16px;
      line-height: 2;
      font-weight: bold;
    }
    .miyawaka-three-column__img {
      max-width: 300px;
      width: 100%;
    }
    .miyawaka-facility {
      margin-top: 60px;
    }
    .miyawaka-facility__title {
      font-size: 2.6rem;
    }
    .facility-table-wrapper {
      width: 100%;
      overflow-x: scroll;
      white-space: nowrap;
    }
    .facility-table-wrapper::-webkit-scrollbar {
      height: 5px;
    }
    .facility-table-wrapper::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    .facility-table-wrapper::-webkit-scrollbar-thumb {
      background: #bcbcbc;
    }
    .facility-table-scroll-hint {
      display: block;
      font-size: 14px;
      margin-bottom: 10px;
    }
    .facility-table {
      font-size: 14px;
    }
    .facility-table__head {
      padding: 15px;
    }
    .facility-table .facility-table__number1,
    .facility-table .facility-table__number2,
    .facility-table .facility-table__number3,
    .facility-table .facility-table__number4,
    .facility-table .facility-table__number5,
    .facility-table .facility-table__number6,
    .facility-table .facility-table__number7,
    .facility-table .facility-table__number8,
    .facility-table .facility-table__number9 {
      padding: 15px 15px 15px 40px;
      vertical-align: middle;
    }
    .facility-table .facility-table__number1::before,
    .facility-table .facility-table__number2::before,
    .facility-table .facility-table__number3::before,
    .facility-table .facility-table__number4::before,
    .facility-table .facility-table__number5::before,
    .facility-table .facility-table__number6::before,
    .facility-table .facility-table__number7::before,
    .facility-table .facility-table__number8::before,
    .facility-table .facility-table__number9::before {
      width: 30px;
      height: 30px;
    }
    .facility-table__data {
      padding: 15px 15px;
    }
    .miyawaka-links {
      margin-top: 60px;
    }
    .miyawaka-links__title {
      font-size: 24px;
    }
    .miyawaka-links__main {
      flex-direction: column;
    }
    .miyawaka-links__link-item {
      text-align: left;
    }
    .miyawaka-links__link-item + .miyawaka-links__link-item {
      margin-left: 0;
      margin-top: 55px;
    }
    .miyawaka-links__img {
      max-width: 435px;
      width: auto;
      height: auto;
    }
    .miyawaka-links__link {
      font-size: 16px;
    }
    .miyawaka-links__group {
      margin-top: 40px;
    }
    .miyawaka-links__group-title {
      font-size: 2rem;
    }
    .miyawaka-conclusion {
      margin-top: 60px;
      border-top: dotted 2px #999;
      padding-top: 40px;
    }

    .c-item {
      padding:0 0 20px 20px;
      width: 100%
    }

    .c-item:nth-child(n+2) {
      margin-top: 30px
    }

    .c-item-info {
      font-size: 14px !important;
    }

    .c-item-title {
      font-size: 14px !important;
    }
  }
`
